import Swiper from 'swiper'
import { FilterSelectEvent } from './filter-select-event'
import {filterPersonDomElements} from "./person-list-filtering";
import {createInfiniteScrollHandler} from "./infinite-scrolling";
import {Navigation, Manipulation} from "swiper/modules";
import {onDomReady} from "../../../shared/ts/helpers/on-dom-ready";
import { refreshSelectMenu } from '../../../shared/ts/select-menu/select-menu-refresh'
import { getSelectMenuInstance } from '../select-menu/select-menu-init'

function init() {
  // person filter and search
  const personListElement = document.querySelector('.person-list');
  if (!personListElement) {
    return;
  }

  const infiniteScrollHandler = createInfiniteScrollHandler(personListElement);

  let selectedLocation =
    personListElement.querySelector('select#person-filter-location')?.value ||
    0;
  let selectedDepartment =
    personListElement.querySelector('select#person-filter-department')?.value ||
    0;
  let selectedName =
    personListElement.querySelector('input#person-filter-name')?.value || '';

  /**
   * @type {{name: string, uid: number, root: number}[]}
   */
  let selectedSpecialFachgebiete = [];
  let isSomeSpecialFachgebietSelected = false;

  const filterPersons = () => {
    if (
      (!!selectedLocation && selectedLocation !== '0') ||
      (!!selectedDepartment && selectedDepartment !== '0') ||
      !!selectedName ||
      isSomeSpecialFachgebietSelected
    ) {
      infiniteScrollHandler?.destroy();
    }

    const hasAnyMatch = filterPersonDomElements(
      personListElement,
      selectedLocation,
      selectedDepartment,
      selectedName,
      isSomeSpecialFachgebietSelected ? selectedSpecialFachgebiete : []
    )

    personListElement
      .querySelectorAll('.col-no-results')
      .forEach(noResultsElement => noResultsElement.hidden = hasAnyMatch)
  };

  const resetFilters = (type) => {
    const filter = document.querySelector('#person-filter-' + type)
    if (!filter) return

    if (filter.hasAttribute('data-options')) {
      const currentValue = filter.value
      filter.innerHTML = filter.dataset.options
      filter.value = currentValue
    } else {
      filter.setAttribute('data-options', filter.innerHTML)
    }

    refreshSelectMenu(filter)
  }

  const updateFilter = (type) => {
    resetFilters(type)

    // remove the useless options of the form element of the given type.
    // useless in this context means, that if the option is selected, no results will show up.
    const usefulFilterOptions = new Set()
    usefulFilterOptions.add('0')

    /**
     * @type {NodeListOf<HTMLElement>}
     */
    const listItems = document.querySelectorAll('.doctor__col')

    for (const listItem of listItems) {
      if (!(listItem.offsetWidth > 0 || listItem.offsetHeight > 0 || listItem.getClientRects().length > 0)) {
        continue
      }

      const dataPayload = listItem.dataset[type === 'location' ? 'standorte' : 'fachgebiete']

      if (dataPayload === null || dataPayload === '') {
        continue
      }

      for (const listItemFilterValue of dataPayload.split(',')) {
        usefulFilterOptions.add(listItemFilterValue)
      }
    }

    /**
     * @type {HTMLSelectElement}
     */
    const filterElement = document.querySelector(`select#person-filter-${type}`)
    for (const optionElement of filterElement.querySelectorAll('option')) {
      if (usefulFilterOptions.has(optionElement.value)) {
        continue
      }

      optionElement.remove()
    }

    refreshSelectMenu(filterElement)
  }

  document.querySelector('#person-filter-location')?.addEventListener('change', function () {
    selectedLocation = this.value
    if (selectedLocation === '0') resetFilters('location')
    filterPersons()
    const deptEl = document.querySelector('#person-filter-department')
    if (deptEl && !deptEl.dataset.isJumpElement) {
      updateFilter('department')
    }
  })

  document.querySelector('#person-filter-department')?.addEventListener('change', function () {
    // dude, idk. I spent more than an hour trying to figure out how to listen
    // for that dump event, but there's nothing there.
    this.dispatchEvent(new FilterSelectEvent())
    selectedDepartment = this.value
    if (selectedDepartment === '0') resetFilters('department')
    filterPersons()
    updateFilter('location')
  })

  document.querySelector('#person-filter-name')?.addEventListener('input', function () {
    selectedName = this.value.toLowerCase()
    filterPersons()
  })

  const personFilterSpecialFachgebietId = 'person-filter-special-fachgebiet'
  const specialFachgebietFilterInputElement = document.getElementById(personFilterSpecialFachgebietId)
  /**
   * @type {{name: string, uid: number, root: number}[]}
   */
  const originalFachgebieteList = specialFachgebietFilterInputElement !== null ?
    JSON.parse(specialFachgebietFilterInputElement.getAttribute('data-special-fachgebiet-options')) : []

  const specialFachgebietSelectSearchSuggestionIdBase = 'person-filter-special-fachgebiet-suggestion'
  const specialFachgebietSuggestSelectElement = document.getElementById(`${specialFachgebietSelectSearchSuggestionIdBase}`)
  let isSpecialFachgebietAutoCompleteActive = false

  specialFachgebietFilterInputElement?.addEventListener('focusin', () => {
    isSpecialFachgebietAutoCompleteActive = true
    updateFachgebietSelectSearchSuggestionState()
  })

  specialFachgebietFilterInputElement?.addEventListener('focusout', () => {
    isSpecialFachgebietAutoCompleteActive = false
    updateFachgebietSelectSearchSuggestionState()
  })

  if (specialFachgebietFilterInputElement && specialFachgebietSuggestSelectElement) {
    document.addEventListener('mousedown', function (event) {
      const instance = getSelectMenuInstance(specialFachgebietSuggestSelectElement)
      const ssContent = instance?.render?.content?.main
      if (!ssContent || !ssContent.contains(event.target)) return

      event.preventDefault()

      const optionEl = event.target.closest('[role="option"]')
      if (!optionEl) return

      const value = optionEl.textContent?.trim() ?? ''
      if (!value) return

      specialFachgebietFilterInputElement.value = value
      isSpecialFachgebietAutoCompleteActive = false
      handleSpecialInputChange(value)
    })
  }

  function updateFachgebietSelectSearchSuggestionState() {
    if (specialFachgebietSuggestSelectElement) {
      refreshSelectMenu(specialFachgebietSuggestSelectElement)
      if (isSpecialFachgebietAutoCompleteActive && selectedSpecialFachgebiete.length !== 0) {
        getSelectMenuInstance(specialFachgebietSuggestSelectElement)?.open()
      } else {
        getSelectMenuInstance(specialFachgebietSuggestSelectElement)?.close()
      }
    }
  }

  function updateFachgebietSelectSearchSuggestion() {
    // remove children
    if(!!specialFachgebietSuggestSelectElement) {
      specialFachgebietSuggestSelectElement.innerText = ''
    }


    if (selectedSpecialFachgebiete.length === 0) {
      return;
    }

    const classNameBase = 'autocomplete-suggestion';

    // if we add something we must add nothing, too
    (() => {
      const element = document.createElement('option')
      element.className = `${classNameBase}`
      element.innerText = ''
      element.setAttribute('data-index', "-1")
      element.value = ''
      element.dataset.placeholder = 'true'
      specialFachgebietSuggestSelectElement.appendChild(element)
    })()

    // add children
    for (let i = 0; i < selectedSpecialFachgebiete.length; i++) {
      const element = document.createElement('option')
      const item = selectedSpecialFachgebiete[i]
      element.className = `${classNameBase}`
      element.innerText = item.name
      element.setAttribute('data-index', i.toString())
      element.value = item.name
      specialFachgebietSuggestSelectElement.appendChild(element)
    }
  }

  /**
   *
   * @param {string} textInput
   * @param applyFilter
   */
  const handleSpecialInputChange = (textInput, applyFilter = true) => {
    selectedSpecialFachgebiete = []

    if (!!textInput) {
      isSomeSpecialFachgebietSelected = true;
      const lowerCasedValue = textInput.toLowerCase()

      for (let i = 0; i < originalFachgebieteList.length; i++) {
        const currentItem = originalFachgebieteList[i]
        const tokens = currentItem.name.toLowerCase().split(" ")
        const selectedDepartmentInt = parseInt(selectedDepartment)
        const matchesFachbereichFilter = selectedDepartmentInt === 0 || currentItem.root === selectedDepartmentInt
        if (matchesFachbereichFilter && (
          currentItem.name?.toLowerCase().startsWith(lowerCasedValue)
          || anyStartsWith(tokens, lowerCasedValue)
        )) {
          selectedSpecialFachgebiete.push(currentItem)
        }
      }
    } else {
      isSomeSpecialFachgebietSelected = false;
    }

    updateFachgebietSelectSearchSuggestion()
    updateFachgebietSelectSearchSuggestionState()
    if (applyFilter) {
      filterPersons()
    }
  }

  handleSpecialInputChange(specialFachgebietFilterInputElement?.value)
  specialFachgebietFilterInputElement?.addEventListener('input', function () {
    isSpecialFachgebietAutoCompleteActive = true
    handleSpecialInputChange(this.value, false)
    // Suppress the fachgebiet filter while the user is mid-type so a previously-committed
    // filter doesn't linger. The filter only (re-)applies on Enter or suggestion selection.
    const savedFlag = isSomeSpecialFachgebietSelected
    isSomeSpecialFachgebietSelected = false
    filterPersons()
    isSomeSpecialFachgebietSelected = savedFlag
  })
  specialFachgebietFilterInputElement?.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      filterPersons()
      getSelectMenuInstance(specialFachgebietSuggestSelectElement)?.close()
    }
  })

  /**
   * Return true, if any item of the strList starts with str.
   *
   * @return {boolean}
   * @param {string[]} strList
   * @param {string} str
   */
  function anyStartsWith(strList, str) {
    for (let i = 0; i < strList.length; i++) {
      if (strList[i].startsWith(str)) {
        return true
      }
    }
    return false
  }

  /**
   * Return true, if base includes any item of check.
   *
   * @template T
   * @param {T[]} base
   * @param {T[]} check
   * @return {boolean}
   */
  function includesAny(base, check) {
    for (let i = 0; i < check.length; i++) {
      if (base.includes(check[i])) {
        return true
      }
    }
    return false
  }

  let personSlides
  let personSlidesContainer
  let personSwiper

  const personListSliders = document.querySelectorAll('.person-list--slider')

  for (const personListSlider of personListSliders) {
    personSlides = personListSlider.querySelectorAll('.swiper-slide')
    personSlidesContainer = personListSlider.querySelector('.swiper-wrapper')
    personSwiper = new Swiper(personListSlider.querySelector('.swiper'), {
      modules: [Navigation, Manipulation],
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: personListSlider.querySelector('.person-list__next'),
        prevEl: personListSlider.querySelector('.person-list__prev'),
      },
      breakpoints: {
        // mobile
        767: {
          slidesPerView: 2, slidesPerGroup: 2,
        },
        // tablet
        1023: {
          slidesPerView: 3, slidesPerGroup: 3,
        },
      },
      loop: false,
    })

    const listNavigation = personListSlider.querySelector('.person-list__navigation')
    const documentWidth = document.body.clientWidth
    listNavigation.hidden = documentWidth > 1023
      ? personSlides.length <= 3
      : personSlides.length > 4

    const filterPersonsInSlider = () => {
      personSwiper.removeAllSlides()
      for (const personSlide of personSlides) {
        const currentEntryLocations = (personSlide.dataset['standorte'] + '').split(',')

        if (selectedLocation === 0 || selectedLocation === "0" || currentEntryLocations.includes(selectedLocation + '')) {
          personSwiper.appendSlide(personSlide)
        }
      }

      personSwiper.update()

      document.querySelectorAll('.doctor-links-filter .links-filter__option').forEach(el => {
        el.classList.remove('links-filter__option--selected')
      })
    }

    document.querySelectorAll('.doctor-links-filter').forEach(function (linksFilter) {
      linksFilter.addEventListener('click', function (e) {
        const option = e.target.closest('.links-filter__option')
        if (option) {
          selectedLocation = option.dataset.uid

          if (!option.classList.contains('links-filter__option--selected')) {
            filterPersonsInSlider()
            option.classList.add('links-filter__option--selected')
          }
        }
      })
    })
  }

  document.querySelectorAll('.doctor__image-container').forEach((element) => {
    const openIcon = element.querySelector('.doctor__open-popup')
    const closeIcon = element.querySelector('.doctor__close-popup')
    const popUp = element.querySelector('.doctor__contact-container')
    const img = element.querySelector('.doctor__image')

    if (openIcon && closeIcon && popUp && img ) {

      const onClick = (e) => {
        popUp.classList.toggle('hidden')
        openIcon.classList.toggle('hidden')
        closeIcon.classList.toggle('hidden')
        img.classList.toggle('opacity')
        e.preventDefault()
      }

      openIcon.addEventListener('click', (e) => onClick(e))
      closeIcon.addEventListener('click', (e) => onClick(e))
    }
  })
}

onDomReady(init)
